export const getOrders = (state) => state.orders
export const getSidebarOpened = (state) => state.sidebar_opened
export const getSelectedOrders = (state) => state.selectedOrders
export const getOccurrences = (state) => state.occurrences
export const getPagination = (state) => state.pagination
export const getHasMore = (state) => state.pagination.hasMore
export const getIsLoadingMore = (state) => state.pagination.isLoadingMore
export const getCacheLoaded = (state) => state.cache
export const getActiveFilterDate = (state) => state.activeFilterDate